<template lang="pug">
  .dataset-showcase
    .mx-12
      h2.acg-heading.d-inline {{title}}
    v-slide-group(:show-arrows="$vuetify.breakpoint.smAndUp")
      v-slide-item(v-for="dataset in datasets" :key="dataset.title")
        Datacard(
          :title="dataset.title"
          :description="dataset.description"
          :number-of-records="dataset.number_of_records"
          :url="dataset.data_source"
          :ext-url="dataset.external_url"
          :download="dataset.s3_location"
          :s3-details="dataset.s3_details"
          :dataset-id="dataset.id"
          :collection-id="dataset.collection ? dataset.collection.id : null"
          :collection-title="dataset.collection ? dataset.collection.title : null"
          :to="{name:'dataset',params:{id:dataset.id}}"
          rows="3"
          show-nav
          hover-details
          style="width:300px"
          showCollection
          :isProtected="dataset.visibility ? dataset.visibility=='protected': false"
        ).ma-4
</template>

<script>
import service from '../data/service'
import Datacard from '@/components/Datacard.vue'

export default {
  props: ['title', 'body', 'data'],
  data: () => ({
    searchedSets: []
  }),
  components: {
    Datacard
  },
  mounted () {
    if(this.body)
      return service.searchDatasets(this.body).then(data => {
        this.searchedSets = data
      })
  },
  computed: {
    datasets() {
      if(this.body)
        return this.searchedSets
      else
        return this.data
    }
  }
}
</script>